// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/profiletype/v1/profiletype.proto" (package "c1.api.profiletype.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * ProfileType represents a type of profile in the system
 *
 * @generated from protobuf message c1.api.profiletype.v1.ProfileType
 */
export interface ProfileType {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: string icon_url = 4
     */
    iconUrl: string;
    /**
     * @generated from protobuf field: uint32 priority = 5
     */
    priority: number;
    /**
     * icon sizes
     *
     * @generated from protobuf field: repeated int32 sizes = 6
     */
    sizes: number[];
    /**
     * Add this field to allow users to reference profile type in cel expressions
     *
     * @generated from protobuf field: string slug = 7
     */
    slug: string;
    /**
     * Whether to display this profile type to users in profile page. Defaults to false if not set
     *
     * @generated from protobuf field: bool display_to_user = 8
     */
    displayToUser: boolean;
}
/**
 * ProfileTypeRef represents a reference to a ProfileType
 *
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeRef
 */
export interface ProfileTypeRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * ProfileTypeUserAttributeMappingBinding represents a binding between a profile type and user attribute mapping
 *
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding
 */
export interface ProfileTypeUserAttributeMappingBinding {
    /**
     * @generated from protobuf field: string profile_type_id = 1
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 2
     */
    userAttributeMappingId: string;
}
// Request messages for ProfileTypeService

/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetRequest
 */
export interface ProfileTypeServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetResponse
 */
export interface ProfileTypeServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1
     */
    profileType?: ProfileType;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateRequest
 */
export interface ProfileTypeServiceCreateRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: bytes icon_data = 3
     */
    iconData: Uint8Array;
    /**
     * @generated from protobuf field: string slug = 4
     */
    slug: string;
    /**
     * @generated from protobuf field: bool display_to_user = 5
     */
    displayToUser: boolean;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateResponse
 */
export interface ProfileTypeServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1
     */
    profileType?: ProfileType;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateRequest
 */
export interface ProfileTypeServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1
     */
    profileType?: ProfileType;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: bytes icon_data = 3
     */
    iconData: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateResponse
 */
export interface ProfileTypeServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1
     */
    profileType?: ProfileType;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteRequest
 */
export interface ProfileTypeServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteResponse
 */
export interface ProfileTypeServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.SetProfileTypeIconRequest
 */
export interface SetProfileTypeIconRequest {
    /**
     * @generated from protobuf field: string profile_type_id = 1
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: bytes data = 2
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.SetProfileTypeIconResponse
 */
export interface SetProfileTypeIconResponse {
}
// Request messages for ProfileTypeSearchService

/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchRequest
 */
export interface ProfileTypeSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeRef refs = 4
     */
    refs: ProfileTypeRef[];
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchResponse
 */
export interface ProfileTypeSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType list = 1
     */
    list: ProfileType[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdRequest
 */
export interface ProfileTypeSearchByAttributeMappingIdRequest {
    /**
     * @generated from protobuf field: string attribute_mapping_id = 1
     */
    attributeMappingId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdResponse
 */
export interface ProfileTypeSearchByAttributeMappingIdResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType list = 1
     */
    list: ProfileType[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListRequest
 */
export interface ProfileTypeUserAttributeMappingBindingServiceListRequest {
    /**
     * @generated from protobuf field: string profile_type_id = 1
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListResponse
 */
export interface ProfileTypeUserAttributeMappingBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding list = 1
     */
    list: ProfileTypeUserAttributeMappingBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateRequest
 */
export interface ProfileTypeUserAttributeMappingBindingServiceUpdateRequest {
    /**
     * @generated from protobuf field: string profile_type_id = 1
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings = 2
     */
    bindings: ProfileTypeUserAttributeMappingBinding[];
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateResponse
 */
export interface ProfileTypeUserAttributeMappingBindingServiceUpdateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings = 1
     */
    bindings: ProfileTypeUserAttributeMappingBinding[];
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest
 */
export interface ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1
     */
    userAttributeMappingId: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse
 */
export interface ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class ProfileType$Type extends MessageType<ProfileType> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "1000" } } } },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "2048" } } } },
            { no: 5, name: "priority", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "sizes", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "255" } } } },
            { no: 8, name: "display_to_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ProfileType>): ProfileType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.description = "";
        message.iconUrl = "";
        message.priority = 0;
        message.sizes = [];
        message.slug = "";
        message.displayToUser = false;
        if (value !== undefined)
            reflectionMergePartial<ProfileType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileType): ProfileType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string icon_url */ 4:
                    message.iconUrl = reader.string();
                    break;
                case /* uint32 priority */ 5:
                    message.priority = reader.uint32();
                    break;
                case /* repeated int32 sizes */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sizes.push(reader.int32());
                    else
                        message.sizes.push(reader.int32());
                    break;
                case /* string slug */ 7:
                    message.slug = reader.string();
                    break;
                case /* bool display_to_user */ 8:
                    message.displayToUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string icon_url = 4; */
        if (message.iconUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconUrl);
        /* uint32 priority = 5; */
        if (message.priority !== 0)
            writer.tag(5, WireType.Varint).uint32(message.priority);
        /* repeated int32 sizes = 6; */
        if (message.sizes.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sizes.length; i++)
                writer.int32(message.sizes[i]);
            writer.join();
        }
        /* string slug = 7; */
        if (message.slug !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.slug);
        /* bool display_to_user = 8; */
        if (message.displayToUser !== false)
            writer.tag(8, WireType.Varint).bool(message.displayToUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileType
 */
export const ProfileType = new ProfileType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeRef$Type extends MessageType<ProfileTypeRef> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeRef>): ProfileTypeRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeRef): ProfileTypeRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeRef
 */
export const ProfileTypeRef = new ProfileTypeRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBinding$Type extends MessageType<ProfileTypeUserAttributeMappingBinding> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBinding>): ProfileTypeUserAttributeMappingBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypeId = "";
        message.userAttributeMappingId = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBinding): ProfileTypeUserAttributeMappingBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string profile_type_id */ 1:
                    message.profileTypeId = reader.string();
                    break;
                case /* string user_attribute_mapping_id */ 2:
                    message.userAttributeMappingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string profile_type_id = 1; */
        if (message.profileTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.profileTypeId);
        /* string user_attribute_mapping_id = 2; */
        if (message.userAttributeMappingId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userAttributeMappingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding
 */
export const ProfileTypeUserAttributeMappingBinding = new ProfileTypeUserAttributeMappingBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceGetRequest$Type extends MessageType<ProfileTypeServiceGetRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceGetRequest>): ProfileTypeServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceGetRequest): ProfileTypeServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetRequest
 */
export const ProfileTypeServiceGetRequest = new ProfileTypeServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceGetResponse$Type extends MessageType<ProfileTypeServiceGetResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceGetResponse", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceGetResponse>): ProfileTypeServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceGetResponse): ProfileTypeServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.profiletype.v1.ProfileType profile_type */ 1:
                    message.profileType = ProfileType.internalBinaryRead(reader, reader.uint32(), options, message.profileType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.profiletype.v1.ProfileType profile_type = 1; */
        if (message.profileType)
            ProfileType.internalBinaryWrite(message.profileType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetResponse
 */
export const ProfileTypeServiceGetResponse = new ProfileTypeServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceCreateRequest$Type extends MessageType<ProfileTypeServiceCreateRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceCreateRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "1000" } } } },
            { no: 3, name: "icon_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1000000" } } } },
            { no: 4, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "255" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 5, name: "display_to_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceCreateRequest>): ProfileTypeServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.iconData = new Uint8Array(0);
        message.slug = "";
        message.displayToUser = false;
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceCreateRequest): ProfileTypeServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* bytes icon_data */ 3:
                    message.iconData = reader.bytes();
                    break;
                case /* string slug */ 4:
                    message.slug = reader.string();
                    break;
                case /* bool display_to_user */ 5:
                    message.displayToUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* bytes icon_data = 3; */
        if (message.iconData.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.iconData);
        /* string slug = 4; */
        if (message.slug !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.slug);
        /* bool display_to_user = 5; */
        if (message.displayToUser !== false)
            writer.tag(5, WireType.Varint).bool(message.displayToUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateRequest
 */
export const ProfileTypeServiceCreateRequest = new ProfileTypeServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceCreateResponse$Type extends MessageType<ProfileTypeServiceCreateResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceCreateResponse", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceCreateResponse>): ProfileTypeServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceCreateResponse): ProfileTypeServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.profiletype.v1.ProfileType profile_type */ 1:
                    message.profileType = ProfileType.internalBinaryRead(reader, reader.uint32(), options, message.profileType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.profiletype.v1.ProfileType profile_type = 1; */
        if (message.profileType)
            ProfileType.internalBinaryWrite(message.profileType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateResponse
 */
export const ProfileTypeServiceCreateResponse = new ProfileTypeServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceUpdateRequest$Type extends MessageType<ProfileTypeServiceUpdateRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceUpdateRequest", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "icon_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1000000" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceUpdateRequest>): ProfileTypeServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.iconData = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceUpdateRequest): ProfileTypeServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.profiletype.v1.ProfileType profile_type */ 1:
                    message.profileType = ProfileType.internalBinaryRead(reader, reader.uint32(), options, message.profileType);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* bytes icon_data */ 3:
                    message.iconData = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.profiletype.v1.ProfileType profile_type = 1; */
        if (message.profileType)
            ProfileType.internalBinaryWrite(message.profileType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bytes icon_data = 3; */
        if (message.iconData.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.iconData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateRequest
 */
export const ProfileTypeServiceUpdateRequest = new ProfileTypeServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceUpdateResponse$Type extends MessageType<ProfileTypeServiceUpdateResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceUpdateResponse", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceUpdateResponse>): ProfileTypeServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceUpdateResponse): ProfileTypeServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.profiletype.v1.ProfileType profile_type */ 1:
                    message.profileType = ProfileType.internalBinaryRead(reader, reader.uint32(), options, message.profileType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.profiletype.v1.ProfileType profile_type = 1; */
        if (message.profileType)
            ProfileType.internalBinaryWrite(message.profileType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateResponse
 */
export const ProfileTypeServiceUpdateResponse = new ProfileTypeServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceDeleteRequest$Type extends MessageType<ProfileTypeServiceDeleteRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeServiceDeleteRequest>): ProfileTypeServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceDeleteRequest): ProfileTypeServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteRequest
 */
export const ProfileTypeServiceDeleteRequest = new ProfileTypeServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceDeleteResponse$Type extends MessageType<ProfileTypeServiceDeleteResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<ProfileTypeServiceDeleteResponse>): ProfileTypeServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeServiceDeleteResponse): ProfileTypeServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteResponse
 */
export const ProfileTypeServiceDeleteResponse = new ProfileTypeServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfileTypeIconRequest$Type extends MessageType<SetProfileTypeIconRequest> {
    constructor() {
        super("c1.api.profiletype.v1.SetProfileTypeIconRequest", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1000000" } } } }
        ]);
    }
    create(value?: PartialMessage<SetProfileTypeIconRequest>): SetProfileTypeIconRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypeId = "";
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetProfileTypeIconRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetProfileTypeIconRequest): SetProfileTypeIconRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string profile_type_id */ 1:
                    message.profileTypeId = reader.string();
                    break;
                case /* bytes data */ 2:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetProfileTypeIconRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string profile_type_id = 1; */
        if (message.profileTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.profileTypeId);
        /* bytes data = 2; */
        if (message.data.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.SetProfileTypeIconRequest
 */
export const SetProfileTypeIconRequest = new SetProfileTypeIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfileTypeIconResponse$Type extends MessageType<SetProfileTypeIconResponse> {
    constructor() {
        super("c1.api.profiletype.v1.SetProfileTypeIconResponse", []);
    }
    create(value?: PartialMessage<SetProfileTypeIconResponse>): SetProfileTypeIconResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetProfileTypeIconResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetProfileTypeIconResponse): SetProfileTypeIconResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetProfileTypeIconResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.SetProfileTypeIconResponse
 */
export const SetProfileTypeIconResponse = new SetProfileTypeIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchRequest$Type extends MessageType<ProfileTypeSearchRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeRef }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeSearchRequest>): ProfileTypeSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeSearchRequest): ProfileTypeSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.profiletype.v1.ProfileTypeRef refs */ 4:
                    message.refs.push(ProfileTypeRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.profiletype.v1.ProfileTypeRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            ProfileTypeRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchRequest
 */
export const ProfileTypeSearchRequest = new ProfileTypeSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchResponse$Type extends MessageType<ProfileTypeSearchResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeSearchResponse>): ProfileTypeSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeSearchResponse): ProfileTypeSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.profiletype.v1.ProfileType list */ 1:
                    message.list.push(ProfileType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.profiletype.v1.ProfileType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ProfileType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchResponse
 */
export const ProfileTypeSearchResponse = new ProfileTypeSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchByAttributeMappingIdRequest$Type extends MessageType<ProfileTypeSearchByAttributeMappingIdRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdRequest", [
            { no: 1, name: "attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeSearchByAttributeMappingIdRequest>): ProfileTypeSearchByAttributeMappingIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attributeMappingId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeSearchByAttributeMappingIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeSearchByAttributeMappingIdRequest): ProfileTypeSearchByAttributeMappingIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string attribute_mapping_id */ 1:
                    message.attributeMappingId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeSearchByAttributeMappingIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string attribute_mapping_id = 1; */
        if (message.attributeMappingId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.attributeMappingId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdRequest
 */
export const ProfileTypeSearchByAttributeMappingIdRequest = new ProfileTypeSearchByAttributeMappingIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchByAttributeMappingIdResponse$Type extends MessageType<ProfileTypeSearchByAttributeMappingIdResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeSearchByAttributeMappingIdResponse>): ProfileTypeSearchByAttributeMappingIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeSearchByAttributeMappingIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeSearchByAttributeMappingIdResponse): ProfileTypeSearchByAttributeMappingIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.profiletype.v1.ProfileType list */ 1:
                    message.list.push(ProfileType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeSearchByAttributeMappingIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.profiletype.v1.ProfileType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ProfileType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdResponse
 */
export const ProfileTypeSearchByAttributeMappingIdResponse = new ProfileTypeSearchByAttributeMappingIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceListRequest$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceListRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListRequest", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBindingServiceListRequest>): ProfileTypeUserAttributeMappingBindingServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypeId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBindingServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBindingServiceListRequest): ProfileTypeUserAttributeMappingBindingServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string profile_type_id */ 1:
                    message.profileTypeId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBindingServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string profile_type_id = 1; */
        if (message.profileTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.profileTypeId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListRequest
 */
export const ProfileTypeUserAttributeMappingBindingServiceListRequest = new ProfileTypeUserAttributeMappingBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceListResponse$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceListResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeUserAttributeMappingBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBindingServiceListResponse>): ProfileTypeUserAttributeMappingBindingServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBindingServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBindingServiceListResponse): ProfileTypeUserAttributeMappingBindingServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding list */ 1:
                    message.list.push(ProfileTypeUserAttributeMappingBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBindingServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ProfileTypeUserAttributeMappingBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListResponse
 */
export const ProfileTypeUserAttributeMappingBindingServiceListResponse = new ProfileTypeUserAttributeMappingBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceUpdateRequest$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateRequest", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeUserAttributeMappingBinding }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest>): ProfileTypeUserAttributeMappingBindingServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypeId = "";
        message.bindings = [];
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBindingServiceUpdateRequest): ProfileTypeUserAttributeMappingBindingServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string profile_type_id */ 1:
                    message.profileTypeId = reader.string();
                    break;
                case /* repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings */ 2:
                    message.bindings.push(ProfileTypeUserAttributeMappingBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string profile_type_id = 1; */
        if (message.profileTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.profileTypeId);
        /* repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings = 2; */
        for (let i = 0; i < message.bindings.length; i++)
            ProfileTypeUserAttributeMappingBinding.internalBinaryWrite(message.bindings[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateRequest
 */
export const ProfileTypeUserAttributeMappingBindingServiceUpdateRequest = new ProfileTypeUserAttributeMappingBindingServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceUpdateResponse$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceUpdateResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateResponse", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeUserAttributeMappingBinding }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBindingServiceUpdateResponse>): ProfileTypeUserAttributeMappingBindingServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bindings = [];
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBindingServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBindingServiceUpdateResponse): ProfileTypeUserAttributeMappingBindingServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings */ 1:
                    message.bindings.push(ProfileTypeUserAttributeMappingBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBindingServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings = 1; */
        for (let i = 0; i < message.bindings.length; i++)
            ProfileTypeUserAttributeMappingBinding.internalBinaryWrite(message.bindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateResponse
 */
export const ProfileTypeUserAttributeMappingBindingServiceUpdateResponse = new ProfileTypeUserAttributeMappingBindingServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest>): ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAttributeMappingId = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest): ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_attribute_mapping_id */ 1:
                    message.userAttributeMappingId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_attribute_mapping_id = 1; */
        if (message.userAttributeMappingId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAttributeMappingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest
 */
export const ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest = new ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse>): ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse): ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse
 */
export const ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse = new ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.profiletype.v1.ProfileTypeService
 */
export const ProfileTypeService = new ServiceType("c1.api.profiletype.v1.ProfileTypeService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeServiceGetRequest, O: ProfileTypeServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeServiceCreateRequest, O: ProfileTypeServiceCreateResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeServiceUpdateRequest, O: ProfileTypeServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeServiceDeleteRequest, O: ProfileTypeServiceDeleteResponse },
    { name: "SetProfileTypeIcon", options: { "authz.method": { role: "EDITOR" } }, I: SetProfileTypeIconRequest, O: SetProfileTypeIconResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.profiletype.v1.ProfileTypeSearchService
 */
export const ProfileTypeSearchService = new ServiceType("c1.api.profiletype.v1.ProfileTypeSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeSearchRequest, O: ProfileTypeSearchResponse },
    { name: "SearchByAttributeMappingId", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeSearchByAttributeMappingIdRequest, O: ProfileTypeSearchByAttributeMappingIdResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingService
 */
export const ProfileTypeUserAttributeMappingBindingService = new ServiceType("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeUserAttributeMappingBindingServiceListRequest, O: ProfileTypeUserAttributeMappingBindingServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, O: ProfileTypeUserAttributeMappingBindingServiceUpdateResponse },
    { name: "CountByUserAttributeMappingId", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, O: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse }
]);
